import SvgArrow from '@img/icons/accordion-arrow.svg';
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { InPageNavigationStyles as S } from './InPageNavigation.styles';
const InPageNavigation = ({ anchors, title }) => {
    const [activeAnchor, setActiveAnchor] = useState(anchors[0]);
    const [fixedNav, setFixedNav] = useState(false);
    const [anchorListOpen, setAnchorListOpen] = useState(false);
    const refContainer = useRef(null);
    const refWrapper = useRef(null);
    const [scrollPercentage, setScrollPercentage] = useState('0%');
    const [navHeight, setNavHeight] = useState(null);
    useEffect(() => {
        applyNavHeight();
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    useLayoutEffect(() => {
        applyNavHeight();
    }, [refWrapper.current, navHeight]);
    const handleScroll = () => {
        fixNav();
        updateScrollProgress();
        updateActiveAnchor();
    };
    const fixNav = () => {
        if (refContainer.current) {
            if (window.scrollY > refContainer.current?.offsetTop) {
                setFixedNav(true);
            }
            else {
                setFixedNav(false);
            }
        }
    };
    const updateScrollProgress = () => {
        const windowHeight = window.innerHeight;
        const totalHeight = document.body.clientHeight - windowHeight;
        const scrollPosition = window.scrollY;
        const percentage = (scrollPosition / totalHeight) * 100;
        setScrollPercentage(`${percentage}%`);
    };
    const updateActiveAnchor = () => {
        for (const item of anchors) {
            const element = document.getElementById(item.id);
            if (element) {
                const style = getComputedStyle(element);
                const scrollMargin = style.getPropertyValue("scroll-margin");
                const scrollMarginTop = parseInt(scrollMargin.split(" ")[0]);
                const { top } = element.getBoundingClientRect();
                if ((top - 50) <= scrollMarginTop) {
                    setActiveAnchor(item);
                }
            }
        }
    };
    const applyNavHeight = () => {
        if (!refWrapper.current)
            return;
        const currentNavHeight = refWrapper.current?.offsetHeight;
        if (currentNavHeight !== navHeight) {
            setNavHeight(currentNavHeight);
        }
    };
    const toggleNav = (open) => {
        setAnchorListOpen(open);
        if (open === true) {
            document.addEventListener('click', navBlur);
        }
    };
    const navBlur = (e) => {
        if (refContainer.current != null && !refContainer.current.contains(e.target)) {
            setAnchorListOpen(false);
            document.removeEventListener('click', () => navBlur);
        }
    };
    const scrollToAnchor = (id) => {
        const anchorPoint = document.getElementById(id);
        if (anchorPoint) {
            anchorPoint.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };
    return (React.createElement(S.Container, { ref: refContainer, "data-ready": navHeight !== null, "data-fixed": fixedNav, style: { height: navHeight || "" } },
        React.createElement(S.Wrapper, { ref: refWrapper },
            React.createElement(S.Inner, null,
                React.createElement(S.Title, null, title.length > 60 ? `${title.slice(0, 59)}...` : title),
                React.createElement(S.Anchors, null,
                    React.createElement(S.ActiveAnchor, { "data-open": anchorListOpen, "data-to-scrollspy-id": activeAnchor.id, onClick: () => toggleNav(!anchorListOpen) },
                        activeAnchor.displayName,
                        React.createElement(S.Arrow, null,
                            React.createElement(SvgArrow, null))),
                    anchors && (React.createElement(S.AnchorList, { "data-open": anchorListOpen }, anchors
                        .filter((anchor) => anchor.id != activeAnchor.id)
                        .map((anchor, index) => (React.createElement(S.AnchorButton, { href: `#${anchor.id}`, key: `anchor-button-${index}`, onClick: (e) => {
                            e.preventDefault();
                            setActiveAnchor(anchor);
                            toggleNav(false);
                            scrollToAnchor(anchor.id);
                        }, "data-to-scrollspy-id": anchor.id }, anchor.displayName))))),
                    React.createElement(S.ProgressBar, null,
                        React.createElement(S.ProgressBarIndicator, { style: { width: scrollPercentage } })))))));
};
export default InPageNavigation;
